import { createFileRoute } from '@tanstack/react-router'
import { LegacyMatchAliasRecovery } from '~/features/football-match-detail/football-match-detail'
import { loadLegacyMatchAliasRoute } from '~/features/football-match-detail/legacy-route-options'
import { handleLegacyMatchAliasRequest } from '~/features/football-match-detail/legacy-server-handler'

export const Route = createFileRoute('/radar/opportunities/$opportunityId')({
  server: {
    handlers: {
      GET: ({ request, params }) => handleLegacyMatchAliasRequest({
        request,
        sourceKind: 'opportunity',
        sourceId: params.opportunityId,
        locale: 'en',
      }),
    },
  },
  loader: ({ params, location }) => loadLegacyMatchAliasRoute({
    sourceKind: 'opportunity',
    sourceId: params.opportunityId,
    locale: 'en',
    location,
  }),
  component: RadarOpportunityLegacyRoute,
  notFoundComponent: () => <LegacyMatchAliasRecovery locale="en" kind="not_found" />,
})

function RadarOpportunityLegacyRoute() {
  const state = Route.useLoaderData()
  return <LegacyMatchAliasRecovery locale="en" kind={state.kind} />
}
